import React, {useState, useEffect, useRef} from 'react';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import {useSelector} from "react-redux";
import MarkDownApp from "../../../../commh5/markDown";

export default function SSEResponse(props) {
  const [response, setResponse] = useState('');
  const {size} = useSelector(state => state.fontSizeChange)
  const handleScrollContainer = ()=>{
    chatEndRef.current?.scrollIntoView({behavior: 'smooth'})
  }
  const answerThree = {
    fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
    paddingTop:'5px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  }
  const chatEndRef = useRef(null);
  const {sendTxt,setSendTxt} = props
  var isLoad = true
  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchEventSource('https://light-word.cn/api/hyperChat', {
          method: 'POST',
          headers: {
            'accept': 'text/event-stream',
            'Content-Type': 'application/json',
            'auth-id': localStorage.getItem('ai-chat-auth-id'),
          },
          body: JSON.stringify(sendTxt),
          onmessage(event) {
            // Handle incoming messages
            // console.log('Received message event:-----------------', event);
            // console.log('Received message:', JSON.parse(event.data)['choices'][0]['delta']['content']);
            if(JSON.parse(event.data)['choices'][0]['delta']['content']!==undefined){
              setResponse((prev) => prev + JSON.parse(event.data)['choices'][0]['delta']['content']);
            }
            setTimeout(()=>{handleScrollContainer()},100)
          },
          onclose() {
            setSendTxt(null)
            isLoad = true
            // Handle connection close
            console.log('Connection to SSE server closed');
          },
          onerror(err) {
            setSendTxt(null)
            isLoad = true
            console.error('SSE error:', err);
          },
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if(isLoad&&sendTxt){
      isLoad = false
      fetchData();
    }
    return () => {
    };
  }, []);

  return (
      <div>
        <div style={answerThree}>
			<MarkDownApp value={response} />
		</div>
        <div ref={chatEndRef}/>
      </div>
  );
}
